import { createRequestActionsSet } from "@store/shared/requestState"

export const getCollections = createRequestActionsSet("collections", "GET_COLLECTIONS")
